var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pb-40 bg-slate-300",
      style: { minHeight: "calc(100vh - 4.5rem - 0.5rem + 100vh)" }
    },
    [
      _c("div", { staticClass: "analytics-sticky bg-slate-300" }, [
        _c(
          "div",
          { staticClass: "py-4 px-6 flex items-center justify-center" },
          [
            _vm.enableBranch
              ? _c("BlTextTitle3", { attrs: { text: "All Branches" } })
              : _c("BlTextTitle3", { attrs: { text: "Center Overview" } })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "px-6 flex items-center justify-center" }, [
          _c(
            "div",
            {
              staticClass:
                "h-8 px-6 flex items-center gap-4 flex-shrink-0 border-b border-slate-400"
            },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "router-link",
                { key: tab.value, attrs: { to: tab.target } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "h-full w-50 flex justify-center border-b-4",
                      class: [
                        tab.isActive
                          ? "border-light-purple"
                          : "border-transparent"
                      ]
                    },
                    [
                      tab.isActive
                        ? _c("BlTextSubtitle2", { attrs: { text: tab.label } })
                        : _c("BlTextBody1", { attrs: { text: tab.label } })
                    ],
                    1
                  )
                ]
              )
            }),
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        !_vm.searchParams["tab"] || _vm.searchParams["tab"] === "clients"
          ? _c(
              "div",
              { staticClass: "py-5 flex flex-col items-center gap-5" },
              [
                _c("CurrentTotal"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex gap-5" },
                  [
                    _c("ClientTurnover", { attrs: { width: "25rem" } }),
                    _vm._v(" "),
                    _c("TeamTurnover")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("TeamPerformance"),
                _vm._v(" "),
                _c("AppointmentOverview"),
                _vm._v(" "),
                _c("CancellationOverview"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex gap-5" },
                  [
                    _c("ClientsWithHighestCancellation", {
                      attrs: { width: "25rem" }
                    }),
                    _vm._v(" "),
                    _c("TherapistsWithHighestCancellation")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ClientHours")
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.searchParams["tab"] === "prospects"
          ? _c(
              "div",
              { staticClass: "py-5 flex flex-col items-center gap-5" },
              [
                _c("ProspectsByStage"),
                _vm._v(" "),
                _c("TotalFinalOutcomesMadeDuringTimeframe"),
                _vm._v(" "),
                _c("ProspectsCountByStage"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex gap-5" },
                  [_c("ReferralSource"), _vm._v(" "), _c("DiscontinuedReason")],
                  1
                ),
                _vm._v(" "),
                _c("Conversion")
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73631747", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73631747","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/CenterOverview.vue
// module id = null
// module chunks = 